import { getGroupsWithStats, orEmptyArray } from '@lms/api-client/backend';
import { LoaderCircle } from 'lucide-react';
import useSWR from 'swr';
import { useLocale, useTranslations } from 'use-intl';
import { PageBox, PageHeader, PageTitle } from '@/components/admin/page-box';
import { useSiteAccess } from '@/features/auth/use-auth';
import { useBrand } from '@/features/branding/brand-provider';
import { GroupQuickStats } from '@/features/groups/components/group-quick-stats';
import ListView from '@/features/groups/components/list-view';

// Ports app/[brand]/admin/groups/page.tsx. The Next page fetched groups and the
// current user server-side; here groups load via SWR and mutations revalidate
// the list in place of `revalidatePath`. Rendered inside the admin <Shell> by admin-app.tsx.
// Everyone with site access can view the list; mutating controls need
// `canManageGroups`.
export function Groups() {
  const t = useTranslations();
  const locale = useLocale();
  const { brand: site, slug } = useBrand();
  const { access } = useSiteAccess(slug);

  const { data: groups, mutate: mutateGroups } = useSWR(
    ['admin/groups-with-stats', site.id, locale],
    () => orEmptyArray(getGroupsWithStats(site.id, locale)),
  );

  if (groups === undefined) {
    return (
      <div className="flex h-64 items-center justify-center">
        <LoaderCircle className="text-primary size-8 animate-spin" />
      </div>
    );
  }

  return (
    <PageBox>
      <PageHeader>
        <PageTitle>{t(`group_alias.${site.groupAlias}`)}</PageTitle>
      </PageHeader>
      <GroupQuickStats site={site} />
      <ListView
        site={site}
        groups={groups}
        canManage={!!access?.canManageGroups}
        onChanged={() => mutateGroups()}
      />
    </PageBox>
  );
}
